// extracted by mini-css-extract-plugin
export default {"subtitle":"QAAy1G","subtitleMobile":"v4AIVM"};